export default __webpack_public_path__ + "static/testimonials-jacobs-50a682397eb91bb9f849d23e4c0a3770.png";